// src/utils/translations.js - 完整版
export const translations = {
  // 中文
  zh: {
    // 通用
    title: '柑仔店收银系统',
    
    // 登录页面
    pleaseLogin: '请登录以继续',
    username: '用户名',
    password: '密码',
    login: '登录',
    loggingIn: '登录中...',
    loginFailed: '登录失败',
    pleaseEnterCredentials: '请输入用户名和密码',
    testAccounts: '测试账号',
    admin: '管理员',
    cashier: '收银员',
    
    // 导航
    pos: '收银台',
    shift: '班次管理',
    dashboard: '数据看板',
    products: '商品管理',
    categories: '分类管理',
    employees: '员工管理',
    
    // 商品管理
    addProduct: '添加商品',
    editProduct: '编辑商品',
    deleteProduct: '删除商品',
    productName: '商品名称',
    barcode: '条码',
    category: '分类',
    price: '价格',
    stock: '库存',
    costPrice: '成本价',
    salePrice: '售价',
    minStock: '最低库存',
    addSuccess: '添加成功',
    addFailed: '添加失败',
    deleteSuccess: '删除成功',
    deleteFailed: '删除失败',
    editFeatureInDevelopment: '编辑功能开发中',
    loadProductsFailed: '加载商品失败',
    operationFailed: '操作失败',
    retry: '重试',
    
    // 收银台
    cart: '购物车',
    total: '总计',
    checkout: '结算',
    paymentMethod: '支付方式',
    cash: '现金',
    card: '刷卡',
    mobile: '移动支付',
    searchPlaceholder: '搜索商品名称或条码...',
    currentShift: '当前班次',
    startingCash: '起始现金',
    noActiveShift: '请先在"班次管理"页面开始班次',
    cartIsEmpty: '购物车是空的！',
    pleaseStartShift: '请先开始班次！',
    orderSuccess: '订单创建成功！',
    orderFailed: '订单创建失败',
    
    // 操作
    save: '保存',
    cancel: '取消',
    confirm: '确认',
    delete: '删除',
    edit: '编辑',
    search: '搜索',
    logout: '退出',
    increase: '增加',
    decrease: '减少',
    
    // 上传
    uploadFailed: '上传失败',
    uploading: '上传中...',
    uploadSuccess: '上传成功'
  },

  // English
  en: {
    // General
    title: 'Retail POS System',
    
    // Login Page
    pleaseLogin: 'Please login to continue',
    username: 'Username',
    password: 'Password',
    login: 'Login',
    loggingIn: 'Logging in...',
    loginFailed: 'Login failed',
    pleaseEnterCredentials: 'Please enter username and password',
    testAccounts: 'Test Accounts',
    admin: 'Admin',
    cashier: 'Cashier',
    
    // Navigation
    pos: 'POS',
    shift: 'Shift Management',
    dashboard: 'Dashboard',
    products: 'Products',
    categories: 'Categories',
    employees: 'Employees',
    
    // Product Management
    addProduct: 'Add Product',
    editProduct: 'Edit Product',
    deleteProduct: 'Delete Product',
    productName: 'Product Name',
    barcode: 'Barcode',
    category: 'Category',
    price: 'Price',
    stock: 'Stock',
    costPrice: 'Cost Price',
    salePrice: 'Sale Price',
    minStock: 'Min Stock',
    addSuccess: 'Added successfully',
    addFailed: 'Failed to add',
    deleteSuccess: 'Deleted successfully',
    deleteFailed: 'Failed to delete',
    editFeatureInDevelopment: 'Edit feature in development',
    loadProductsFailed: 'Failed to load products',
    operationFailed: 'Operation failed',
    retry: 'Retry',
    
    // POS
    cart: 'Shopping Cart',
    total: 'Total',
    checkout: 'Checkout',
    paymentMethod: 'Payment Method',
    cash: 'Cash',
    card: 'Card',
    mobile: 'Mobile Payment',
    searchPlaceholder: 'Search product name or barcode...',
    currentShift: 'Current Shift',
    startingCash: 'Starting Cash',
    noActiveShift: 'Please start a shift in "Shift Management" first',
    cartIsEmpty: 'Cart is empty!',
    pleaseStartShift: 'Please start a shift first!',
    orderSuccess: 'Order created successfully!',
    orderFailed: 'Failed to create order',
    
    // Actions
    save: 'Save',
    cancel: 'Cancel',
    confirm: 'Confirm',
    delete: 'Delete',
    edit: 'Edit',
    search: 'Search',
    logout: 'Logout',
    increase: 'Increase',
    decrease: 'Decrease',
    
    // Upload
    uploadFailed: 'Upload failed',
    uploading: 'Uploading...',
    uploadSuccess: 'Upload successful'
  },

  // ខ្មែរ (Khmer)
  km: {
    // ទូទៅ
    title: 'ប្រព័ន្ធលក់រាយ',
    
    // ទំព័រចូល
    pleaseLogin: 'សូមចូលដើម្បីបន្ត',
    username: 'ឈ្មោះអ្នកប្រើ',
    password: 'ពាក្យសម្ងាត់',
    login: 'ចូល',
    loggingIn: 'កំពុងចូល...',
    loginFailed: 'ការចូលបានបរាជ័យ',
    pleaseEnterCredentials: 'សូមបញ្ចូលឈ្មោះអ្នកប្រើនិងពាក្យសម្ងាត់',
    testAccounts: 'គណនីសាកល្បង',
    admin: 'អ្នកគ្រប់គ្រង',
    cashier: 'អ្នកគិតលុយ',
    
    // ការរុករក
    pos: 'ម៉ាស៊ីនគិតលុយ',
    shift: 'គ្រប់គ្រងវេន',
    dashboard: 'ផ្ទាំងគ្រប់គ្រង',
    products: 'ទំនិញ',
    categories: 'ប្រភេទ',
    employees: 'បុគ្គលិក',
    
    // គ្រប់គ្រងទំនិញ
    addProduct: 'បន្ថែមទំនិញ',
    editProduct: 'កែសម្រួលទំនិញ',
    deleteProduct: 'លុបទំនិញ',
    productName: 'ឈ្មោះទំនិញ',
    barcode: 'បាកូដ',
    category: 'ប្រភេទ',
    price: 'តម្លៃ',
    stock: 'ស្តុក',
    costPrice: 'តម្លៃដើម',
    salePrice: 'តម្លៃលក់',
    minStock: 'ស្តុកអប្បបរមា',
    addSuccess: 'បានបន្ថែមដោយជោគជ័យ',
    addFailed: 'បរាជ័យក្នុងការបន្ថែម',
    deleteSuccess: 'បានលុបដោយជោគជ័យ',
    deleteFailed: 'បរាជ័យក្នុងការលុប',
    editFeatureInDevelopment: 'មុខងារកែសម្រួលកំពុងអភិវឌ្ឍ',
    loadProductsFailed: 'បរាជ័យក្នុងការផ្ទុកទំនិញ',
    operationFailed: 'ប្រតិបត្តិការបានបរាជ័យ',
    retry: 'ព្យាយាមម្តងទៀត',
    
    // ម៉ាស៊ីនគិតលុយ
    cart: 'រទេះទិញ',
    total: 'សរុប',
    checkout: 'គិតលុយ',
    paymentMethod: 'វិធីបង់ប្រាក់',
    cash: 'សាច់ប្រាក់',
    card: 'កាត',
    mobile: 'បង់តាមទូរស័ព្ទ',
    searchPlaceholder: 'ស្វែងរកឈ្មោះទំនិញ ឬបាកូដ...',
    currentShift: 'វេនបច្ចុប្បន្ន',
    startingCash: 'សាច់ប្រាក់ដំបូង',
    noActiveShift: 'សូមចាប់ផ្តើមវេននៅក្នុង "គ្រប់គ្រងវេន" ជាមុនសិន',
    cartIsEmpty: 'រទេះទិញទទេ!',
    pleaseStartShift: 'សូមចាប់ផ្តើមវេនជាមុនសិន!',
    orderSuccess: 'បង្កើតការបញ្ជាទិញបានជោគជ័យ!',
    orderFailed: 'បរាជ័យក្នុងការបង្កើតការបញ្ជាទិញ',
    
    // សកម្មភាព
    save: 'រក្សាទុក',
    cancel: 'បោះបង់',
    confirm: 'បញ្ជាក់',
    delete: 'លុប',
    edit: 'កែសម្រួល',
    search: 'ស្វែងរក',
    logout: 'ចេញ',
    increase: 'បន្ថែម',
    decrease: 'បន្ថយ',
    
    // ផ្ទុកឡើង
    uploadFailed: 'បរាជ័យក្នុងការផ្ទុកឡើង',
    uploading: 'កំពុងផ្ទុកឡើង...',
    uploadSuccess: 'ផ្ទុកឡើងបានជោគជ័យ'
  }
};